import {portalModalHeaderActionTypes} from "./actionTypes"

export function setPrevRoute(payload) {
    return {
        type: portalModalHeaderActionTypes.SET_PREV_ROUTE,
        payload
    }
}
